import React from 'react';
import { call, put } from 'redux-saga/effects';

import { toast } from 'react-toastify';
import { Creators as RequisicaoActions } from '../ducks/requisicao';

import { WarningToast } from '../../components/molecules/Toast';
import { requisitionAPI } from '../../services/api';

export function* getPermissaoSegundaVia(action) {
  const { params } = action.payload;

  try {
    const response = yield call(requisitionAPI.get, `/allowed/${params}`);
    const isSuccess = response.status === 200 || false;

    yield put(
      RequisicaoActions.getPermissaoSegundaViaSuccess(response.data, isSuccess)
    );
  } catch (error) {
    yield put(RequisicaoActions.getPermissaoSegundaViaError(error));
    toast.error(<WarningToast>{error.response.data}</WarningToast>);
  }
}
export function* postSolicitarRelatorioSegundaVia(action) {
  const { params } = action.payload;

  const tipo = {
    Detalhado: '/relatorio-detalhado-excel',
    Resumido: '/relatorio-resumido-csv',
  };
  try {
    const response = yield call(
      requisitionAPI.post,
      tipo[params.tipoRelatorio],
      params
    );
    const isSuccess = response.status === 200 || false;

    yield put(
      RequisicaoActions.postSolicitarRelatorioSegundaViaSuccess(
        response.data,
        isSuccess
      )
    );
  } catch (error) {
    yield put(RequisicaoActions.postSolicitarRelatorioSegundaViaError(error));
    toast.error(<WarningToast>{error.response.data}</WarningToast>);
  }
}
export function* postSolicitarSegundaVia(action) {
  const { params } = action.payload;
  try {
    const response = yield call(requisitionAPI.post, `/create`, params);
    const isSuccess = response.status === 200 || false;

    yield put(
      RequisicaoActions.postSolicitarSegundaViaSuccess(response.data, isSuccess)
    );
  } catch (error) {
    yield put(RequisicaoActions.postSolicitarSegundaViaError(error));
    toast.error(<WarningToast>{error.response.data}</WarningToast>);
  }
}

export function* getBeneficiariosSegundaVia(action) {
  const { params } = action.payload;
  try {
    const response = yield call(requisitionAPI.post, `/beneficiaries`, params);
    const isSuccess = response.status === 200 || false;

    yield put(
      RequisicaoActions.postBeneficiarioegundaViaSuccess(
        response.data,
        isSuccess
      )
    );
  } catch (error) {
    yield put(RequisicaoActions.postBeneficiarioegundaViaError(error));
    toast.error(<WarningToast>{error.response.data}</WarningToast>);
  }
}
export function* deleteSegundaVia(action) {
  const { params } = action.payload;
  try {
    const response = yield call(
      requisitionAPI.put,
      `/delete/${params.requisitionId}/${params.userId}`
    );
    const isSuccess = response.status === 200 || false;

    yield put(
      RequisicaoActions.deleteSegundaViaSuccess(response.data, isSuccess)
    );
  } catch (error) {
    yield put(RequisicaoActions.deleteSegundaViaError(error));
    toast.error(<WarningToast>{error.response.data}</WarningToast>);
  }
}
export function* getSegundaViaAnexo(action) {
  const { params } = action.payload;
  try {
    const response = yield call(requisitionAPI.get, `/attachment/${params}`);
    const isSuccess = response.status === 200 || false;

    yield put(
      RequisicaoActions.getSegundaViaAnexoSuccess(response.data, isSuccess)
    );
  } catch (error) {
    yield put(RequisicaoActions.getSegundaViaAnexoError(error));
    toast.error(<WarningToast>{error.response.data}</WarningToast>);
  }
}

export function* deleteSegundaViaAnexo(action) {
  const { params } = action.payload;
  try {
    const response = yield call(requisitionAPI.delete, `/attachment/${params}`);
    const isSuccess = response.status === 200 || false;

    yield put(
      RequisicaoActions.deleteSegundaViaAnexoSuccess(response.data, isSuccess)
    );
  } catch (error) {
    yield put(RequisicaoActions.deleteSegundaViaAnexoError(error));
    toast.error(<WarningToast>{error.response.data}</WarningToast>);
  }
}
export function* putSegundaVia(action) {
  const { params } = action.payload;

  try {
    const response = yield call(requisitionAPI.put, `/update`, params);
    const isSuccess = response.status === 200 || false;

    yield put(
      RequisicaoActions.putSegundaViaUpdateSuccess(response.data, isSuccess)
    );
  } catch (error) {
    yield put(RequisicaoActions.putSegundaViaUpdateError(error));
    toast.error(<WarningToast>{error.response.data}</WarningToast>);
  }
}
export function* postSegundaViaBuscarPorId(action) {
  const { params } = action.payload;

  try {
    const response = yield call(
      requisitionAPI.post,
      `/filter-after-update`,
      params
    );
    const isSuccess = response.status === 200 || false;

    yield put(
      RequisicaoActions.postSegundaViaBuscarPorIdSuccess(
        response.data,
        isSuccess
      )
    );
  } catch (error) {
    yield put(RequisicaoActions.postSegundaViaBuscarPorIdError(error));
    toast.error(
      <WarningToast>{error.response.data.error_message}</WarningToast>
    );
  }
}

export function* postSegundaViaProcessar(action) {
  const { params } = action.payload;
  try {
    const response = yield call(requisitionAPI.post, `/process`, params);
    const isSuccess = response.status === 200 || false;

    yield put(
      RequisicaoActions.postSegundaViaProcessarSuccess(response.data, isSuccess)
    );
  } catch (error) {
    yield put(RequisicaoActions.postSegundaViaProcessarError(error));
  }
}

export function* postSegundaViaCartao(action) {
  const { params } = action.payload;
  try {
    const response = yield call(requisitionAPI.post, `/filter`, params);
    const isSuccess = response.status === 200 || false;

    yield put(
      RequisicaoActions.postSegundaViaCartaoSuccess(response.data, isSuccess)
    );
  } catch (error) {
    yield put(RequisicaoActions.postSegundaViaCartaoError(error));
  }
}
